(()=>{
  if(window.__corsaillePass93)return;window.__corsaillePass93=true;
  const root=document.documentElement;
  const syncViewport=()=>{
    const vv=window.visualViewport;
    if(!vv){root.style.setProperty('--corsaille-vv-bottom','0px');return;}
    const offset=Math.max(0,window.innerHeight-vv.height-vv.offsetTop);
    root.style.setProperty('--corsaille-vv-bottom',`${Math.round(offset)}px`);
  };
  syncViewport();
  window.addEventListener('resize',syncViewport,{passive:true});
  window.addEventListener('orientationchange',()=>setTimeout(syncViewport,120),{passive:true});
  if(window.visualViewport){
    visualViewport.addEventListener('resize',syncViewport,{passive:true});
    visualViewport.addEventListener('scroll',syncViewport,{passive:true});
  }
})();
